import { defineNuxtPlugin } from '#app/nuxt'
import { LazyBlockCities, LazyBlockFindTariffs, LazyBlockHelp, LazyBlockOneClick, LazyBlockReviews, LazyDBreadcrumbs, LazyDBtn, LazyDCustomRate, LazyDFooter, LazyDFooterPartner, LazyDHat, LazyDHatPartner, LazyDHatPartnerNew, LazyDHeaderMb, LazyDHeaderPartner, LazyDHeaderPartnerNew, LazyDHeaderPc, LazyDLoader, LazyDMainLoader, LazyDSpinner, LazyDTextAreaPlaceholder, LazyEntryPageArea, LazyEntryPageMain, LazyEntryPagePersonal, LazyEntryPageStatic, LazyEntryPageStreet, LazyModalAddressCheck, LazyModalAddressCheckAdditional, LazyModalAddressCheckNew, LazyModalAddressVerification, LazyModalAuthorization, LazyModalCallMe, LazyModalCallMeAutomatLarge, LazyModalCallMeAutomatSmall, LazyModalCallMeAutomatization, LazyModalCallMeDateTimePicker, LazyModalCallMeDateTimePickerNew, LazyModalCallMePartners, LazyModalCallMeSegmentation, LazyModalCallMeSupport, LazyModalCallMeSupportOld, LazyModalCheckoutHelp, LazyModalCheckoutPartnersHelp, LazyModalCityChanged, LazyModalCityCheck, LazyModalCityWrap, LazyModalDeviceAdd, LazyModalMap, LazyModalNew60sec, LazyModalNew60segmentation, LazyModalPartnersCallMe, LazyModalPartnersConsult, LazyModalPartnersFastOrder, LazyModalPartnersFastSecondOrder, LazyModalQuiz, LazyModalStreetsSelect, LazyModalTariff, LazyModalTariffFastSecondOrder, LazyModalTariffOrder, LazyModalTariffOrderPatners, LazyModalTariffSegmentation, LazyModalVerification, LazyThatsWhy, LazyVCheckbox, LazyVCollapse, LazyVDateInput, LazyVDatePicker, LazyVDialog, LazyVLazy, LazyVList, LazyVListItem, LazyVMenu, LazyVMobileDrawer, LazyVNotification, LazyVNotificationCard, LazyVPhoneInput, LazyVProgressCirc, LazyVRadio, LazyVRadioItem, LazyVRangeSlider, LazyVRating, LazyVSkeleton, LazyVSwiper, LazyVSwitch, LazyVTextInput, LazyVTooltip, LazyVScroll, LazyWantBestTariffs, LazyWantBestTariffsPartners, LazyWantBestTariffsPartnersOld, LazyWantBestTariffsProviders, LazyWantBestTariffsWhite, LazyBaseTsDBtn, LazyBaseTsInput, LazyAboutPagePartners, LazyAddressCheck, LazyAddressCheckSmall, LazyAddressCheckSAPartnersCheck, LazyAddressCheckSearchAddressCheck, LazyBlogPageBlogContent, LazyBlogPageBlogMenu, LazyBlogPageBlogPreview, LazyBlogPageBlogSimilarPosts, LazyBlogPageBlogTable, LazyBlogPageBlogTariff, LazyCareerFamiliarity, LazyCareerFooter, LazyCareerForm, LazyCareerHat, LazyCareerJoin, LazyCareerLast, LazyCareerOffer, LazyCareerPartners, LazyCareerPhoto, LazyCareerReviews, LazyCareerSteps, LazyCheckoutFooter, LazyCheckoutHeader, LazyCheckoutOrder, LazyCheckoutPartnersHeader, LazyCheckoutPartnersOrder, LazyCheckoutPrice, LazyCompareHelp, LazyCompareItemHeader, LazyDownDetectorDDComment, LazyDownDetectorDDComments, LazyDownDetectorDDCommentsForm, LazyDownDetectorDDModalNotWorking, LazyDownDetectorDDModalThanks, LazyDownDetectorDDProviderAbout, LazyDownDetectorDDProviderDayCrashes, LazyDownDetectorDDProviderFakeCard, LazyDownDetectorDDProviderGeo, LazyDownDetectorDDProviderSmallCard, LazyDownDetectorDDProviderText, LazyHelpCard, LazyHelpHeader, LazyHelpSide, LazyLocationsRegion, LazyMainPageCallMeBtn, LazyMainPageAbout, LazyMainPageBlog, LazyMainPageBlogSection, LazyMainPageCities, LazyMainPageCollect, LazyMainPageConnect, LazyMainPageHelp, LazyMainPageLatestConnected, LazyMainPageProviders, LazyMainPageMainProfitable, LazyMainPagePopularLargeTariffs, LazyMainPagePopularProviders, LazyMainPagePopularTariffs, LazyMainPageProvidersNewCarousel, LazyMainPageStreetText, LazyMainPageTariffsSuggestonNew, LazyNavigateMobileNavbar, LazyOrderPageModalRate, LazyOrderPageAnotherOrders, LazyOrderPageCard, LazyOrderPageCarousel, LazyOrderPageProgressLine, LazyPartnersActiveTariffs, LazyPartnersCallMeBtn, LazyPartnersCheckAvailability, LazyPartnersEntryPageContacts, LazyPartnersEntryPageMain, LazyPartnersEntryPageMainNew, LazyPartnersEntryPageStaticPartners, LazyPartnersEntryPageTariffs, LazyPartnersEntryPageTariffsNew, LazyPartnersHatBenefits, LazyPartnersHowConnect, LazyPartnersMainBonus, LazyPartnersModal, LazyPartnersPageQuestion, LazyPartnersSearchForm, LazyPartnersPhoneBlock, LazyPartnersPromoSwiper, LazyPartnersTariffViewedPartners, LazyPartnersTariffsCardPartners, LazyPartnersTariffsSuggestonPartners, LazyProviderPagePromoSwiper, LazyProviderPageAbout, LazyProviderPageAboutPartner, LazyProviderPageBenefits, LazyProviderPageCheckaddress, LazyProviderPageCheckaddressPartner, LazyProviderPageContacts, LazyProviderPageDeviceCard, LazyProviderPageDevices, LazyProviderPageFastOrder, LazyProviderPageFooter, LazyProviderPageHeader, LazyProviderPageMain, LazyProviderPageMainPartner, LazyProviderPageReviewCard, LazyProviderPageReviews, LazyProviderPageSmallHeader, LazyProviderPageProviderReviewsPage, LazyProviderPageProviderReviewsPagePartners, LazyProviderPageProvidersPageQuestion, LazyProvidersPageProvidersBestList, LazyProvidersPageProvidersCardNew, LazyProvidersPageProvidersCardNewLoading, LazyProvidersPageProvidersEnemyCard, LazyProvidersPageProvidersFastForm, LazyProvidersPageProvidersHelpBlock, LazyProvidersPageProvidersLargeCard, LazyProvidersPageProvidersLargeCardSkeleton, LazyProvidersPageProvidersNF, LazyProvidersPageProvidersSmallCard, LazyProvidersPageProvidersTable, LazyProvidersPageProvidersWrapper, LazyQuizBlock, LazyQuizModalLoader, LazyQuizResultFooter, LazyQuizTariff, LazyQuizTariffCard, LazyQuizTariffDevice, LazyRatingPageRatingCardFake, LazyRatingPageRatingCardNew, LazyRatingPageRatingFast, LazyRatingPageGlobalFast, LazyRatingPageTable, LazyRatingPageRatingText, LazyRatingPageRatingTopProviders, LazyRatingPageRatingTopProvidersCard, LazyRatingPageRatingTopProvidersGroup, LazyRatingPageRatingWrapperNew, LazyReviewsPageReviewsAddReviewCard, LazyReviewsPageReviewsCard, LazyReviewsPageReviewsCardSkeleton, LazyReviewsPageReviewsComment, LazyReviewsPageReviewsComments, LazyReviewsPageReviewsLeaveComment, LazyReviewsPageReviewsLeaveReview, LazyReviewsPageReviewsLeaveReviewHorizontal, LazyReviewsPageReviewsMyReviews, LazyReviewsPageReviewsMyReviewsCard, LazyReviewsPageReviewsProviderCard, LazyReviewsPageReviewsProviderCarousel, LazyReviewsPageReviewsRateLine, LazyReviewsPageReviewsWrapper, LazySearchAddressPageSearchAddressCNA, LazySearchAddressPageSearchAddressFAQ, LazySearchAddressPageSearchAddressHouses, LazySearchAddressPageSearchAddressProviders, LazySearchAddressPageSearchAddressProvidersCover, LazySearchAddressPageSearchAddressStepsLong, LazySearchAddressPageSearchAddressStepsShort, LazySpeedtestStAbout, LazySpeedtestStCheck, LazySpeedtestStCheckCmd, LazySpeedtestStCrushed, LazySpeedtestStEvening, LazySpeedtestStHeader, LazySpeedtestStRating, LazySpeedtestStRouter, LazySpeedtestStSpeed, LazySpeedtestStSpeedUp, LazySubscriptionsCard, LazySubscriptionsCardLoading, LazySubscriptionsServiceCard, LazySubscriptionsShowTariffs, LazySubscriptionsSubHeader, LazyTariffPageTariffCallMe, LazyTariffPageTariffCard, LazyTariffPageTariffDevice, LazyTariffPageTariffFastOrder, LazyTariffPageTariffModalNA, LazyTariffPageTariffModalPrice, LazyTariffPageTariffProviderInfo, LazyTariffPageTariffViewed, LazyTariffsPageTariffsAddressWrapper, LazyTariffsPageTariffsCard, LazyTariffsPageTariffsCardHelp, LazyTariffsPageTariffsCardNew, LazyTariffsPageTariffsCardSkeleton, LazyTariffsPageTariffsFastConnection, LazyTariffsPageTariffsFilters, LazyTariffsPageTariffsHelper, LazyTariffsPageText, LazyTariffsPageTariffsSelection, LazyTariffsPageTariffsServiceBtns, LazyTariffsPageTariffsSmartFilter, LazyTariffsPageTariffsTable, LazyTariffsPageTariffsText, LazyTariffsPageTariffsWrapper, LazyTariffsPageTariffsWrapperPartners, LazyTariffsPageTariffsWrapperProvider } from '#components'
const lazyGlobalComponents = [
  ["BlockCities", LazyBlockCities],
["BlockFindTariffs", LazyBlockFindTariffs],
["BlockHelp", LazyBlockHelp],
["BlockOneClick", LazyBlockOneClick],
["BlockReviews", LazyBlockReviews],
["DBreadcrumbs", LazyDBreadcrumbs],
["DBtn", LazyDBtn],
["DCustomRate", LazyDCustomRate],
["DFooter", LazyDFooter],
["DFooterPartner", LazyDFooterPartner],
["DHat", LazyDHat],
["DHatPartner", LazyDHatPartner],
["DHatPartnerNew", LazyDHatPartnerNew],
["DHeaderMb", LazyDHeaderMb],
["DHeaderPartner", LazyDHeaderPartner],
["DHeaderPartnerNew", LazyDHeaderPartnerNew],
["DHeaderPc", LazyDHeaderPc],
["DLoader", LazyDLoader],
["DMainLoader", LazyDMainLoader],
["DSpinner", LazyDSpinner],
["DTextAreaPlaceholder", LazyDTextAreaPlaceholder],
["EntryPageArea", LazyEntryPageArea],
["EntryPageMain", LazyEntryPageMain],
["EntryPagePersonal", LazyEntryPagePersonal],
["EntryPageStatic", LazyEntryPageStatic],
["EntryPageStreet", LazyEntryPageStreet],
["ModalAddressCheck", LazyModalAddressCheck],
["ModalAddressCheckAdditional", LazyModalAddressCheckAdditional],
["ModalAddressCheckNew", LazyModalAddressCheckNew],
["ModalAddressVerification", LazyModalAddressVerification],
["ModalAuthorization", LazyModalAuthorization],
["ModalCallMe", LazyModalCallMe],
["ModalCallMeAutomatLarge", LazyModalCallMeAutomatLarge],
["ModalCallMeAutomatSmall", LazyModalCallMeAutomatSmall],
["ModalCallMeAutomatization", LazyModalCallMeAutomatization],
["ModalCallMeDateTimePicker", LazyModalCallMeDateTimePicker],
["ModalCallMeDateTimePickerNew", LazyModalCallMeDateTimePickerNew],
["ModalCallMePartners", LazyModalCallMePartners],
["ModalCallMeSegmentation", LazyModalCallMeSegmentation],
["ModalCallMeSupport", LazyModalCallMeSupport],
["ModalCallMeSupportOld", LazyModalCallMeSupportOld],
["ModalCheckoutHelp", LazyModalCheckoutHelp],
["ModalCheckoutPartnersHelp", LazyModalCheckoutPartnersHelp],
["ModalCityChanged", LazyModalCityChanged],
["ModalCityCheck", LazyModalCityCheck],
["ModalCityWrap", LazyModalCityWrap],
["ModalDeviceAdd", LazyModalDeviceAdd],
["ModalMap", LazyModalMap],
["ModalNew60sec", LazyModalNew60sec],
["ModalNew60segmentation", LazyModalNew60segmentation],
["ModalPartnersCallMe", LazyModalPartnersCallMe],
["ModalPartnersConsult", LazyModalPartnersConsult],
["ModalPartnersFastOrder", LazyModalPartnersFastOrder],
["ModalPartnersFastSecondOrder", LazyModalPartnersFastSecondOrder],
["ModalQuiz", LazyModalQuiz],
["ModalStreetsSelect", LazyModalStreetsSelect],
["ModalTariff", LazyModalTariff],
["ModalTariffFastSecondOrder", LazyModalTariffFastSecondOrder],
["ModalTariffOrder", LazyModalTariffOrder],
["ModalTariffOrderPatners", LazyModalTariffOrderPatners],
["ModalTariffSegmentation", LazyModalTariffSegmentation],
["ModalVerification", LazyModalVerification],
["ThatsWhy", LazyThatsWhy],
["VCheckbox", LazyVCheckbox],
["VCollapse", LazyVCollapse],
["VDateInput", LazyVDateInput],
["VDatePicker", LazyVDatePicker],
["VDialog", LazyVDialog],
["VLazy", LazyVLazy],
["VList", LazyVList],
["VListItem", LazyVListItem],
["VMenu", LazyVMenu],
["VMobileDrawer", LazyVMobileDrawer],
["VNotification", LazyVNotification],
["VNotificationCard", LazyVNotificationCard],
["VPhoneInput", LazyVPhoneInput],
["VProgressCirc", LazyVProgressCirc],
["VRadio", LazyVRadio],
["VRadioItem", LazyVRadioItem],
["VRangeSlider", LazyVRangeSlider],
["VRating", LazyVRating],
["VSkeleton", LazyVSkeleton],
["VSwiper", LazyVSwiper],
["VSwitch", LazyVSwitch],
["VTextInput", LazyVTextInput],
["VTooltip", LazyVTooltip],
["VScroll", LazyVScroll],
["WantBestTariffs", LazyWantBestTariffs],
["WantBestTariffsPartners", LazyWantBestTariffsPartners],
["WantBestTariffsPartnersOld", LazyWantBestTariffsPartnersOld],
["WantBestTariffsProviders", LazyWantBestTariffsProviders],
["WantBestTariffsWhite", LazyWantBestTariffsWhite],
["BaseTsDBtn", LazyBaseTsDBtn],
["BaseTsInput", LazyBaseTsInput],
["AboutPagePartners", LazyAboutPagePartners],
["AddressCheck", LazyAddressCheck],
["AddressCheckSmall", LazyAddressCheckSmall],
["AddressCheckSAPartnersCheck", LazyAddressCheckSAPartnersCheck],
["AddressCheckSearchAddressCheck", LazyAddressCheckSearchAddressCheck],
["BlogPageBlogContent", LazyBlogPageBlogContent],
["BlogPageBlogMenu", LazyBlogPageBlogMenu],
["BlogPageBlogPreview", LazyBlogPageBlogPreview],
["BlogPageBlogSimilarPosts", LazyBlogPageBlogSimilarPosts],
["BlogPageBlogTable", LazyBlogPageBlogTable],
["BlogPageBlogTariff", LazyBlogPageBlogTariff],
["CareerFamiliarity", LazyCareerFamiliarity],
["CareerFooter", LazyCareerFooter],
["CareerForm", LazyCareerForm],
["CareerHat", LazyCareerHat],
["CareerJoin", LazyCareerJoin],
["CareerLast", LazyCareerLast],
["CareerOffer", LazyCareerOffer],
["CareerPartners", LazyCareerPartners],
["CareerPhoto", LazyCareerPhoto],
["CareerReviews", LazyCareerReviews],
["CareerSteps", LazyCareerSteps],
["CheckoutFooter", LazyCheckoutFooter],
["CheckoutHeader", LazyCheckoutHeader],
["CheckoutOrder", LazyCheckoutOrder],
["CheckoutPartnersHeader", LazyCheckoutPartnersHeader],
["CheckoutPartnersOrder", LazyCheckoutPartnersOrder],
["CheckoutPrice", LazyCheckoutPrice],
["CompareHelp", LazyCompareHelp],
["CompareItemHeader", LazyCompareItemHeader],
["DownDetectorDDComment", LazyDownDetectorDDComment],
["DownDetectorDDComments", LazyDownDetectorDDComments],
["DownDetectorDDCommentsForm", LazyDownDetectorDDCommentsForm],
["DownDetectorDDModalNotWorking", LazyDownDetectorDDModalNotWorking],
["DownDetectorDDModalThanks", LazyDownDetectorDDModalThanks],
["DownDetectorDDProviderAbout", LazyDownDetectorDDProviderAbout],
["DownDetectorDDProviderDayCrashes", LazyDownDetectorDDProviderDayCrashes],
["DownDetectorDDProviderFakeCard", LazyDownDetectorDDProviderFakeCard],
["DownDetectorDDProviderGeo", LazyDownDetectorDDProviderGeo],
["DownDetectorDDProviderSmallCard", LazyDownDetectorDDProviderSmallCard],
["DownDetectorDDProviderText", LazyDownDetectorDDProviderText],
["HelpCard", LazyHelpCard],
["HelpHeader", LazyHelpHeader],
["HelpSide", LazyHelpSide],
["LocationsRegion", LazyLocationsRegion],
["MainPageCallMeBtn", LazyMainPageCallMeBtn],
["MainPageAbout", LazyMainPageAbout],
["MainPageBlog", LazyMainPageBlog],
["MainPageBlogSection", LazyMainPageBlogSection],
["MainPageCities", LazyMainPageCities],
["MainPageCollect", LazyMainPageCollect],
["MainPageConnect", LazyMainPageConnect],
["MainPageHelp", LazyMainPageHelp],
["MainPageLatestConnected", LazyMainPageLatestConnected],
["MainPageProviders", LazyMainPageProviders],
["MainPageMainProfitable", LazyMainPageMainProfitable],
["MainPagePopularLargeTariffs", LazyMainPagePopularLargeTariffs],
["MainPagePopularProviders", LazyMainPagePopularProviders],
["MainPagePopularTariffs", LazyMainPagePopularTariffs],
["MainPageProvidersNewCarousel", LazyMainPageProvidersNewCarousel],
["MainPageStreetText", LazyMainPageStreetText],
["MainPageTariffsSuggestonNew", LazyMainPageTariffsSuggestonNew],
["NavigateMobileNavbar", LazyNavigateMobileNavbar],
["OrderPageModalRate", LazyOrderPageModalRate],
["OrderPageAnotherOrders", LazyOrderPageAnotherOrders],
["OrderPageCard", LazyOrderPageCard],
["OrderPageCarousel", LazyOrderPageCarousel],
["OrderPageProgressLine", LazyOrderPageProgressLine],
["PartnersActiveTariffs", LazyPartnersActiveTariffs],
["PartnersCallMeBtn", LazyPartnersCallMeBtn],
["PartnersCheckAvailability", LazyPartnersCheckAvailability],
["PartnersEntryPageContacts", LazyPartnersEntryPageContacts],
["PartnersEntryPageMain", LazyPartnersEntryPageMain],
["PartnersEntryPageMainNew", LazyPartnersEntryPageMainNew],
["PartnersEntryPageStaticPartners", LazyPartnersEntryPageStaticPartners],
["PartnersEntryPageTariffs", LazyPartnersEntryPageTariffs],
["PartnersEntryPageTariffsNew", LazyPartnersEntryPageTariffsNew],
["PartnersHatBenefits", LazyPartnersHatBenefits],
["PartnersHowConnect", LazyPartnersHowConnect],
["PartnersMainBonus", LazyPartnersMainBonus],
["PartnersModal", LazyPartnersModal],
["PartnersPageQuestion", LazyPartnersPageQuestion],
["PartnersSearchForm", LazyPartnersSearchForm],
["PartnersPhoneBlock", LazyPartnersPhoneBlock],
["PartnersPromoSwiper", LazyPartnersPromoSwiper],
["PartnersTariffViewedPartners", LazyPartnersTariffViewedPartners],
["PartnersTariffsCardPartners", LazyPartnersTariffsCardPartners],
["PartnersTariffsSuggestonPartners", LazyPartnersTariffsSuggestonPartners],
["ProviderPagePromoSwiper", LazyProviderPagePromoSwiper],
["ProviderPageAbout", LazyProviderPageAbout],
["ProviderPageAboutPartner", LazyProviderPageAboutPartner],
["ProviderPageBenefits", LazyProviderPageBenefits],
["ProviderPageCheckaddress", LazyProviderPageCheckaddress],
["ProviderPageCheckaddressPartner", LazyProviderPageCheckaddressPartner],
["ProviderPageContacts", LazyProviderPageContacts],
["ProviderPageDeviceCard", LazyProviderPageDeviceCard],
["ProviderPageDevices", LazyProviderPageDevices],
["ProviderPageFastOrder", LazyProviderPageFastOrder],
["ProviderPageFooter", LazyProviderPageFooter],
["ProviderPageHeader", LazyProviderPageHeader],
["ProviderPageMain", LazyProviderPageMain],
["ProviderPageMainPartner", LazyProviderPageMainPartner],
["ProviderPageReviewCard", LazyProviderPageReviewCard],
["ProviderPageReviews", LazyProviderPageReviews],
["ProviderPageSmallHeader", LazyProviderPageSmallHeader],
["ProviderPageProviderReviewsPage", LazyProviderPageProviderReviewsPage],
["ProviderPageProviderReviewsPagePartners", LazyProviderPageProviderReviewsPagePartners],
["ProviderPageProvidersPageQuestion", LazyProviderPageProvidersPageQuestion],
["ProvidersPageProvidersBestList", LazyProvidersPageProvidersBestList],
["ProvidersPageProvidersCardNew", LazyProvidersPageProvidersCardNew],
["ProvidersPageProvidersCardNewLoading", LazyProvidersPageProvidersCardNewLoading],
["ProvidersPageProvidersEnemyCard", LazyProvidersPageProvidersEnemyCard],
["ProvidersPageProvidersFastForm", LazyProvidersPageProvidersFastForm],
["ProvidersPageProvidersHelpBlock", LazyProvidersPageProvidersHelpBlock],
["ProvidersPageProvidersLargeCard", LazyProvidersPageProvidersLargeCard],
["ProvidersPageProvidersLargeCardSkeleton", LazyProvidersPageProvidersLargeCardSkeleton],
["ProvidersPageProvidersNF", LazyProvidersPageProvidersNF],
["ProvidersPageProvidersSmallCard", LazyProvidersPageProvidersSmallCard],
["ProvidersPageProvidersTable", LazyProvidersPageProvidersTable],
["ProvidersPageProvidersWrapper", LazyProvidersPageProvidersWrapper],
["QuizBlock", LazyQuizBlock],
["QuizModalLoader", LazyQuizModalLoader],
["QuizResultFooter", LazyQuizResultFooter],
["QuizTariff", LazyQuizTariff],
["QuizTariffCard", LazyQuizTariffCard],
["QuizTariffDevice", LazyQuizTariffDevice],
["RatingPageRatingCardFake", LazyRatingPageRatingCardFake],
["RatingPageRatingCardNew", LazyRatingPageRatingCardNew],
["RatingPageRatingFast", LazyRatingPageRatingFast],
["RatingPageGlobalFast", LazyRatingPageGlobalFast],
["RatingPageTable", LazyRatingPageTable],
["RatingPageRatingText", LazyRatingPageRatingText],
["RatingPageRatingTopProviders", LazyRatingPageRatingTopProviders],
["RatingPageRatingTopProvidersCard", LazyRatingPageRatingTopProvidersCard],
["RatingPageRatingTopProvidersGroup", LazyRatingPageRatingTopProvidersGroup],
["RatingPageRatingWrapperNew", LazyRatingPageRatingWrapperNew],
["ReviewsPageReviewsAddReviewCard", LazyReviewsPageReviewsAddReviewCard],
["ReviewsPageReviewsCard", LazyReviewsPageReviewsCard],
["ReviewsPageReviewsCardSkeleton", LazyReviewsPageReviewsCardSkeleton],
["ReviewsPageReviewsComment", LazyReviewsPageReviewsComment],
["ReviewsPageReviewsComments", LazyReviewsPageReviewsComments],
["ReviewsPageReviewsLeaveComment", LazyReviewsPageReviewsLeaveComment],
["ReviewsPageReviewsLeaveReview", LazyReviewsPageReviewsLeaveReview],
["ReviewsPageReviewsLeaveReviewHorizontal", LazyReviewsPageReviewsLeaveReviewHorizontal],
["ReviewsPageReviewsMyReviews", LazyReviewsPageReviewsMyReviews],
["ReviewsPageReviewsMyReviewsCard", LazyReviewsPageReviewsMyReviewsCard],
["ReviewsPageReviewsProviderCard", LazyReviewsPageReviewsProviderCard],
["ReviewsPageReviewsProviderCarousel", LazyReviewsPageReviewsProviderCarousel],
["ReviewsPageReviewsRateLine", LazyReviewsPageReviewsRateLine],
["ReviewsPageReviewsWrapper", LazyReviewsPageReviewsWrapper],
["SearchAddressPageSearchAddressCNA", LazySearchAddressPageSearchAddressCNA],
["SearchAddressPageSearchAddressFAQ", LazySearchAddressPageSearchAddressFAQ],
["SearchAddressPageSearchAddressHouses", LazySearchAddressPageSearchAddressHouses],
["SearchAddressPageSearchAddressProviders", LazySearchAddressPageSearchAddressProviders],
["SearchAddressPageSearchAddressProvidersCover", LazySearchAddressPageSearchAddressProvidersCover],
["SearchAddressPageSearchAddressStepsLong", LazySearchAddressPageSearchAddressStepsLong],
["SearchAddressPageSearchAddressStepsShort", LazySearchAddressPageSearchAddressStepsShort],
["SpeedtestStAbout", LazySpeedtestStAbout],
["SpeedtestStCheck", LazySpeedtestStCheck],
["SpeedtestStCheckCmd", LazySpeedtestStCheckCmd],
["SpeedtestStCrushed", LazySpeedtestStCrushed],
["SpeedtestStEvening", LazySpeedtestStEvening],
["SpeedtestStHeader", LazySpeedtestStHeader],
["SpeedtestStRating", LazySpeedtestStRating],
["SpeedtestStRouter", LazySpeedtestStRouter],
["SpeedtestStSpeed", LazySpeedtestStSpeed],
["SpeedtestStSpeedUp", LazySpeedtestStSpeedUp],
["SubscriptionsCard", LazySubscriptionsCard],
["SubscriptionsCardLoading", LazySubscriptionsCardLoading],
["SubscriptionsServiceCard", LazySubscriptionsServiceCard],
["SubscriptionsShowTariffs", LazySubscriptionsShowTariffs],
["SubscriptionsSubHeader", LazySubscriptionsSubHeader],
["TariffPageTariffCallMe", LazyTariffPageTariffCallMe],
["TariffPageTariffCard", LazyTariffPageTariffCard],
["TariffPageTariffDevice", LazyTariffPageTariffDevice],
["TariffPageTariffFastOrder", LazyTariffPageTariffFastOrder],
["TariffPageTariffModalNA", LazyTariffPageTariffModalNA],
["TariffPageTariffModalPrice", LazyTariffPageTariffModalPrice],
["TariffPageTariffProviderInfo", LazyTariffPageTariffProviderInfo],
["TariffPageTariffViewed", LazyTariffPageTariffViewed],
["TariffsPageTariffsAddressWrapper", LazyTariffsPageTariffsAddressWrapper],
["TariffsPageTariffsCard", LazyTariffsPageTariffsCard],
["TariffsPageTariffsCardHelp", LazyTariffsPageTariffsCardHelp],
["TariffsPageTariffsCardNew", LazyTariffsPageTariffsCardNew],
["TariffsPageTariffsCardSkeleton", LazyTariffsPageTariffsCardSkeleton],
["TariffsPageTariffsFastConnection", LazyTariffsPageTariffsFastConnection],
["TariffsPageTariffsFilters", LazyTariffsPageTariffsFilters],
["TariffsPageTariffsHelper", LazyTariffsPageTariffsHelper],
["TariffsPageText", LazyTariffsPageText],
["TariffsPageTariffsSelection", LazyTariffsPageTariffsSelection],
["TariffsPageTariffsServiceBtns", LazyTariffsPageTariffsServiceBtns],
["TariffsPageTariffsSmartFilter", LazyTariffsPageTariffsSmartFilter],
["TariffsPageTariffsTable", LazyTariffsPageTariffsTable],
["TariffsPageTariffsText", LazyTariffsPageTariffsText],
["TariffsPageTariffsWrapper", LazyTariffsPageTariffsWrapper],
["TariffsPageTariffsWrapperPartners", LazyTariffsPageTariffsWrapperPartners],
["TariffsPageTariffsWrapperProvider", LazyTariffsPageTariffsWrapperProvider],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
